<div class="promotion-code-child-component">
  <div class="promotion-currency-row">
    <h5>Promotion Currency</h5>
    <div *ngIf="isEditMode">
      <p>Current Players: <span>{{ activeCurrencyStats('current_players') }}</span></p> 
      <p>Budget Used: <span>{{ activeCurrency }} {{ activeCurrencyStats('used_budget') }}</span></p>
    </div>
  </div>
  <div class="promotion-code-child-component-content">
    <div class="currency-row">
      <p>Currency:</p>
      <ul>
        <li *ngFor="let currency of dropdown.currencies; let i = index"
            [class.active]="activeCurrencyId === currency.id"
            (click)="selectCurrency(currency.id)">
          {{ currency.name }}
        </li>
      </ul>
    </div>

    <div *ngIf="activeCurrencyId"> 
      <form [formGroup]="getCurrencyForm(activeCurrencyId)">
        <div class="row">
          <div class="col-4 mb-4">
            <span class="kt-font-bold">Max Total Application <span class="text-danger">*</span></span>
            <input class="form-control" type="number" min="0" formControlName="max_total_applications" value="0" (wheel)="$event.preventDefault()" (keydown)="onNumberKeydown($event)"  (paste)="onPaste($event)" (blur)="checkAndReset('max_total_applications')"/>
            <span class="reminder-text">Enter 0 for unlimited</span>
          </div>
          <div class="col-4 mb-4">
            <span class="kt-font-bold">Max Total Amount <span class="text-danger">*</span></span>
            <input class="form-control" type="number" min="0" formControlName="max_total_bonus" value="0" (wheel)="$event.preventDefault()" (keydown)="onNumberKeydown($event)"  (paste)="onPaste($event)" (blur)="checkAndReset('max_total_bonus')"/>
            <span class="reminder-text">Enter 0 for unlimited</span>
          </div>

          <ng-container *ngIf="initialData?.promotion_type == 'BTG Promotion'">
            <!-- Promotion Phase 1 -->
            <div class="col-12">
              <span class="phase-heading">Promotion Phase 1</span>
            </div>
            <div class="col-4 mb-4">
              <span class="kt-font-bold">Starting Amount <span class="text-danger">*</span></span>
              <div class="currency-input">
                <span>{{ activeCurrency }}</span>
                <input class="form-control" type="number" formControlName="phase1_starting_amount" (wheel)="$event.preventDefault()" disabled/>
              </div>
            </div>
            <div class="col-4 mb-4">
              <span class="kt-font-bold">Target Requirement Type <span class="text-danger">*</span></span>
              <select formControlName="phase1_target_type" class="form-control" disabled>
                <option [ngValue]="null" disabled>Please Select</option>
                <option [ngValue]="6">Turnover</option>
                <option [ngValue]="7">Winover</option>
              </select>
            </div>
            <div class="col-4 mb-4">
              <span class="kt-font-bold">Target Amount <span class="text-danger">*</span></span>
              <div class="currency-input">
                <span>{{ activeCurrency }}</span>
                <input class="form-control" type="number" formControlName="phase1_target_amount" (wheel)="$event.preventDefault()" disabled/>
              </div>
            </div>

            <!-- Promotion Phase 2 -->
            <div class="col-12">
              <span class="phase-heading">Promotion Phase 2</span>
            </div>
            <div class="col-4 mb-4">
              <span class="kt-font-bold">Starting Amount <span class="text-danger">*</span></span>
              <div class="currency-input">
                <span>{{ activeCurrency }}</span>
                <input class="form-control" type="number" formControlName="phase2_starting_amount" (wheel)="$event.preventDefault()" disabled/>
              </div>
            </div>
            <div class="col-4 mb-4">
              <span class="kt-font-bold">Target Requirement Type <span class="text-danger">*</span></span>
              <select formControlName="phase2_target_type" class="form-control">
                <option [ngValue]="null" disabled>Please Select</option>
                <option [ngValue]="6">Turnover</option>
                <option [ngValue]="7">Winover</option>
              </select>
            </div>
            <div class="col-4 mb-4">
              <span class="kt-font-bold">Target Amount <span class="text-danger">*</span></span>
              <div class="currency-input">
                <span>{{ activeCurrency }}</span>
                <input class="form-control" type="number" value="0" min="0" formControlName="phase2_target_amount" (wheel)="$event.preventDefault()" (keydown)="onNumberKeydown($event)"  (paste)="onPaste($event)"  (blur)="checkAndReset('phase2_target_amount')"/>
              </div>
            </div>

            <div class="col-4 mb-4">
              <span class="kt-font-bold">Max Transfer Out <span class="text-danger">*</span>
                <i class="fas fa-exclamation-circle" matTooltip='The maximum amount a member can transfer out upon promotion unlock.
This condition will be bypass if "Limit Provider Transfer Out" is OFF
Recommended to enable "Unlock Upon Transfer Out" if this field is configured' matTooltipClass="custom-tooltip-multiline" matTooltipHideDelay="0"></i>
              </span>
              <div class="currency-input">
                <span>{{ activeCurrency }}</span>
                <input class="form-control" type="number" value="0" min="0" formControlName="max_transfer_out" (wheel)="$event.preventDefault()" (keydown)="onNumberKeydown($event)"  (paste)="onPaste($event)"  (blur)="checkAndReset('max_transfer_out')"/>
              </div>
              <span class="reminder-text">Enter 0 for unlimited</span>
            </div>
          </ng-container>

          <ng-container *ngIf="initialData?.promotion_type == 'PP Promotion'">
            <!-- Promotion Phase 1 -->
            <div class="col-12">
              <span class="phase-heading">Promotion Phase 1</span>
            </div>
            <div class="col-4 mb-4">
              <span class="kt-font-bold">Amount Per Line <span class="text-danger">*</span></span>
              <div class="currency-input">
                <input class="form-control pl-3" type="number" min="0.01" step="0.01" formControlName="amount_per_line" (wheel)="$event.preventDefault()" (keydown)="onNumberKeydown($event)"  (paste)="onPaste($event, 'amount_per_line')"  (blur)="checkAndReset('amount_per_line')" [readonly]="initialData.promotion_type === 'PP Promotion' && isEditMode"/>
              </div>
            </div>
            <div class="col-4 mb-4">
              <span class="kt-font-bold">Total Rounds <span class="text-danger">*</span></span>
              <div class="currency-input">
                <input class="form-control pl-3" type="number" min="1" max="1000" step="1" formControlName="rounds" (wheel)="$event.preventDefault()" (keydown)="onNumberKeydown($event, 'rounds')"  (paste)="onPaste($event, 'rounds')"  (blur)="checkAndReset('rounds')" [readonly]="initialData.promotion_type === 'PP Promotion' && isEditMode"/>
              </div>
            </div>
            <div class="col-4 mb-4">
              <span class="kt-font-bold">Bonus Round Winning Amount <span class="text-danger">*</span>
                <i class="fas fa-exclamation-circle" matTooltip=' The total amount needed to be won in the FRB round by the player to progress to Phase 2.' matTooltipClass="custom-tooltip" matTooltipHideDelay="0"></i>
              </span>
              <div class="currency-input">
                <span>{{ activeCurrency }}</span>
                <input class="form-control" type="number" formControlName="phase1_target_amount" (wheel)="$event.preventDefault()" (keydown)="onNumberKeydown($event)"  (paste)="onPaste($event)"  (blur)="checkAndReset('phase1_target_amount')" [readonly]="initialData.promotion_type === 'PP Promotion' && isEditMode"/>
              </div>
            </div>

            <!-- Promotion Phase 2 -->
            <div class="col-12">
              <span class="phase-heading">Promotion Phase 2</span>
            </div>
            <div class="col-4 mb-4">
              <span class="kt-font-bold">Starting Amount <span class="text-danger">*</span></span>
              <div class="currency-input">
                <span>{{ activeCurrency }}</span>
                <input class="form-control" type="number" min="0.01" step="0.01" formControlName="phase2_starting_amount" (wheel)="$event.preventDefault()" (keydown)="onNumberKeydown($event)"  (paste)="onPaste($event)"  (blur)="checkAndReset('phase2_starting_amount')"/>
              </div>
              <span class="reminder-text text-danger" *ngIf="isPhase2StartingAmountInvalid()">Starting Amount must be greater than 0</span>
            </div>
            <div class="col-4 mb-4">
              <span class="kt-font-bold">Target Requirement Type <span class="text-danger">*</span></span>
              <select formControlName="phase2_target_type" class="form-control">
                <option [ngValue]="null" disabled>Please Select</option>
                <option [ngValue]="6">Turnover</option>
                <option [ngValue]="7">Winover</option>
              </select>
            </div>
            <div class="col-4 mb-4">
              <span class="kt-font-bold">Target Amount <span class="text-danger">*</span></span>
              <div class="currency-input">
                <span>{{ activeCurrency }}</span>
                <input class="form-control" type="number" value="0" min="0" formControlName="phase2_target_amount" (wheel)="$event.preventDefault()" (keydown)="onNumberKeydown($event)"  (paste)="onPaste($event)"  (blur)="checkAndReset('phase2_target_amount')"/>
              </div>
            </div>

            <div class="col-4 mb-4">
              <span class="kt-font-bold">Max Transfer Out <span class="text-danger">*</span>
                <i class="fas fa-exclamation-circle" matTooltip='The maximum amount a member can transfer out upon promotion unlock.
This condition will be bypass if "Limit Provider Transfer Out" is OFF
Recommended to enable "Unlock Upon Transfer Out" if this field is configured' matTooltipClass="custom-tooltip-multiline" matTooltipHideDelay="0"></i>
              </span>
              <div class="currency-input">
                <span>{{ activeCurrency }}</span>
                <input class="form-control" type="number" value="0" min="0" formControlName="max_transfer_out" (wheel)="$event.preventDefault()" (keydown)="onNumberKeydown($event)"  (paste)="onPaste($event)"  (blur)="checkAndReset('max_transfer_out')"/>
              </div>
              <span class="reminder-text">Enter 0 for unlimited</span>
            </div>
          </ng-container>

          <!-- Free Spin: free-round params only (phase inputs are intentionally hidden) -->
          <ng-container *ngIf="initialData?.promotion_type == 'Free Spin'">
            <div class="col-4 mb-4">
              <span class="kt-font-bold">Amount Per Line <span class="text-danger">*</span></span>
              <div class="currency-input">
<!-- Bet-value providers (PTI, JILI2): Amount Per Line is picked from provider bet values (mirrors v1); other providers keep free input -->
                <select *ngIf="hasBetValues" class="form-control pl-3" formControlName="amount_per_line" [attr.disabled]="(betValuesLoading || (isEditMode && isCurrencyConfigured(activeCurrencyId))) ? true : null">
                  <option [ngValue]="null" [disabled]="true">Please Select</option>
                  <option *ngFor="let bv of getBetValuesForActive()" [ngValue]="bv.value">{{ bv.label }}</option>
                </select>
                <!-- Sits left of the native select caret while the provider's bet values load -->
                <i *ngIf="hasBetValues && betValuesLoading" class="spinner-border spinner-border-sm" style="position: absolute; right: 35px; top: calc(50% - 0.5rem);"></i>
                <input *ngIf="!hasBetValues" class="form-control pl-3" type="number" min="0.01" step="0.01" formControlName="amount_per_line" (wheel)="$event.preventDefault()" (keydown)="onNumberKeydown($event)"  (paste)="onPaste($event, 'amount_per_line')"  (blur)="checkAndReset('amount_per_line')" [readonly]="isEditMode && isCurrencyConfigured(activeCurrencyId)"/>
              </div>
              <span *ngIf="hasBetValues && !betValuesLoading && betValuesError" class="text-danger" style="font-size:11px;">{{ betValuesError }}</span>
            </div>
            <div class="col-4 mb-4">
              <span class="kt-font-bold">Total Rounds <span class="text-danger">*</span></span>
              <div class="currency-input">
                <input class="form-control pl-3" type="number" min="1" max="1000" step="1" formControlName="rounds" (wheel)="$event.preventDefault()" (keydown)="onNumberKeydown($event, 'rounds')"  (paste)="onPaste($event, 'rounds')"  (blur)="checkAndReset('rounds')" [readonly]="isEditMode && isCurrencyConfigured(activeCurrencyId)"/>
              </div>
            </div>
            <div class="col-4 mb-4">
              <span class="kt-font-bold">Line <span class="text-danger">*</span></span>
              <div class="currency-input">
                <input class="form-control pl-3" type="number" min="1" step="1" formControlName="lines" (wheel)="$event.preventDefault()" (keydown)="onNumberKeydown($event)"  (paste)="onPaste($event, 'lines')"  (blur)="checkAndReset('lines')" [readonly]="isEditMode && isCurrencyConfigured(activeCurrencyId)"/>
              </div>
            </div>
            <div class="col-4 mb-4">
              <span class="kt-font-bold">Coin <span class="text-danger">*</span></span>
              <div class="currency-input">
                <input class="form-control pl-3" type="number" min="1" step="1" formControlName="coins" (wheel)="$event.preventDefault()" (keydown)="onNumberKeydown($event)"  (paste)="onPaste($event, 'coins')"  (blur)="checkAndReset('coins')" [readonly]="isEditMode && isCurrencyConfigured(activeCurrencyId)"/>
              </div>
            </div>
            <div class="col-4 mb-4">
              <span class="kt-font-bold">Min Transfer <span class="text-danger">*</span></span>
              <div class="currency-input">
                <input class="form-control pl-3" type="number" value="0" min="0" formControlName="min_transfer" (wheel)="$event.preventDefault()" (keydown)="onNumberKeydown($event)"  (paste)="onPaste($event)"  (blur)="checkAndReset('min_transfer')"/>
              </div>
            </div>
            <div class="col-4 mb-4">
              <span class="kt-font-bold">Max Transfer Out <span class="text-danger">*</span>
                <i class="fas fa-exclamation-circle" matTooltip='The maximum amount a member can transfer out upon promotion unlock.
This condition will be bypass if "Limit Provider Transfer Out" is OFF
Recommended to enable "Unlock Upon Transfer Out" if this field is configured' matTooltipClass="custom-tooltip-multiline" matTooltipHideDelay="0"></i>
              </span>
              <div class="currency-input">
                <input class="form-control pl-3" type="number" value="0" min="0" formControlName="max_transfer_out" (wheel)="$event.preventDefault()" (keydown)="onNumberKeydown($event)"  (paste)="onPaste($event)"  (blur)="checkAndReset('max_transfer_out')"/>
              </div>
              <span class="reminder-text">Enter 0 for unlimited</span>
            </div>
            <div class="col-4 mb-4">
              <span class="kt-font-bold">Status</span>
              <div class="toggle-button row">
                <div class="col-10 p-0">
                  <p>Status of the Promotion.</p>
                </div>
                <div class="col-2 p-0 switch">
                  <input type="checkbox" formControlName="status" [checked]="getCurrencyForm(activeCurrencyId).value.status == 1" (change)="onChangeStatus($event)">
                  <div class="slider round">
                    <span class="on">ON</span>
                    <span class="off">OFF</span>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </form>
    </div>
  </div>
</div>
